const CLARITY_ID = 'w9libb2ccu'

let initialized = false

declare global {
  interface Window {
    clarity: any
  }
}

export function initClarity() {
  if (initialized) return
  if (typeof window === 'undefined') return

  try {
    window.clarity =
      window.clarity ||
      function () {
        ;(window.clarity.q = window.clarity.q || []).push(arguments)
      }

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`
    document.head.appendChild(script)

    initialized = true
  } catch (e) {
    console.warn('Clarity init error:', e)
  }
}
